import {PartialTenantCustomizations} from "src/tenantCustomizations/TenantCustomizations.ts";
import {
	SsaCustomerOrderDegreeOfReadinessApi
} from "src/api/generated/tenants/ssa/sales/ssaCustomerOrderDegreeOfReadinessApi.ts";
import {
	getInventoryLevelEventQuantitySpcSamplingMethod,
	getInventoryLevelEventTotalWeightSpcSamplingMethod,
} from "src/components/views/erp/spcSamplingMethods/inventoryLevelEventSpcSamplingMethods.tsx";
import { defaultSpcSamplingMethods } from "src/tenantCustomizations/defaultTenantCustomizations.ts";

export const ssaCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			reclamationsEnabled: true,
			configuratorEnabled: true,
			defaultCustomerType: "COMPANY",
		},
		tasks: {
			enabled: true,
		},
		documentsEnabled: true,
		workspacesEnabled: true,
	},
	spcSamplingMethods: () => [
		...defaultSpcSamplingMethods,
		getInventoryLevelEventQuantitySpcSamplingMethod(),
		getInventoryLevelEventTotalWeightSpcSamplingMethod(),
	],
	erp: {
		sales: {
			printCustomerOrderDegreeOfReadinessReport:
				SsaCustomerOrderDegreeOfReadinessApi.printCustomerOrderDegreeOfReadinessReport,
		},
	},
};
